import { combineEpics } from 'redux-observable';
import { ContactPermission } from '@reducers/data/shareStatuses/contacts';
import { createSharingActions, createSharingEpicActionCreators, createSharingEpics } from './utils';

const actionCreators = createSharingEpicActionCreators('CONTACT');

export const {
  fetchShareStatus: fetchContactShareStatus,
  shareWithEmail: shareContactWithEmail,
  unshareWithSharee: unshareContactWithSharee,
  addPermissionForSharee: addContactPermissionForSharee,
  removePermissionForSharee: removeContactPermissionForSharee,
  sharePublicly: shareContactPublicly,
  unsharePublicly: unshareContactPublicly,
  addPublicPermission: addContactPublicPermission,
  removePublicPermission: removeContactPublicPermission,
} = createSharingActions<ContactPermission>('CONTACT', actionCreators);

export const contactShareStatusesEpic = combineEpics(
  ...createSharingEpics('CONTACT', actionCreators),
);
